import React from 'react';

import App from './app';
import Layout from './layout';

export default () => {
  return <Layout><App/></Layout>;
}